<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

	<v-container fluid>

		<v-row>
			<v-col>


				<v-row class="my-0 py-0">
					<v-col cols="12" class="my-0 py-0">
						<v-card>
							<v-card-text class="py-0">
								<v-row>
									<v-col cols="3">
										<p class="title text--primary ml-3 mt-2">Επιλεγμένα Σημεία
											Διανομής</p>
									</v-col>
									<v-col cols="9" class="py-0 ma-0 mt-2"
										   v-if="selectedDistPointsHaveNoMembership">
										<v-alert class="py-1" color="red" style="max-width: 905px"
												 dense border="left" outlined>
											Εντοπίστηκαν Σημεία Διανομής που δεν έχουν επιβεβαιώσει τη συμμετοχή τους για το ακαδημαϊκό έτος
											{{returnYearText($store.getters.editedYear)}} ,
											και ως εκ τούτου δεν είναι εφικτό να αντιστοιχιστούν σε επιλεγμένα συγγράμματά σας,
											παρακαλούμε όπως τα εξετάσετε και προβείτε στις κατάλληλες ενέργειες.
										</v-alert>
									</v-col>
								</v-row>


								<v-row>
									<v-col cols="4">
										<v-text-field
												append-icon="search"
												hide-details clearable
												label="Αναζήτηση"
												single-line @click:clear="search=''"
												v-model="search"
										></v-text-field>
									</v-col>
									<v-col cols="8" xl="8" lg="8" md="6" sm="6" class="pa-0 mt-2">
										<v-chip-group
												v-model="firstTableFilter"
												mandatory class="mt-2 ml-2">
											<v-chip
													filter
													outlined
													color="primary"
													value="all">
												Όλα
											</v-chip>
											<v-chip class="ml-2"
													filter
													outlined
													color="primary"
													value="noMembers">
												Χωρίς συμμετοχή
											</v-chip>
											<v-chip class="ml-2"
													filter
													outlined
													color="primary"
													value="members">
												Με συμμετοχή
											</v-chip>
										</v-chip-group>
									</v-col>
								</v-row>

								<v-data-table :headers="headers" :key="tableRerenderKey"
											  :items="firstTableFilteredItems"
											  dense :sort-by="['cityName']"
											  :sort-desc="[false]"
											  item-key="id"
											  no-data-text="Δεν υπάρχουν δεδομένα.">

									<template v-slot:item.distributionPointName="{ item }">
										<template v-if="!item.hasMembership">
											<v-tooltip top>
												<template v-slot:activator="{ on, attrs }">
													<v-chip v-on="on" v-bind="attrs"
															color="red" outlined class="my-1"
															dense shaped>
														<v-icon left size="21" class="mr-1">
															mdi-alert-outline
														</v-icon>
														{{ item.distributionPointName }}
													</v-chip>
												</template>
												<span>Το σημείο διανομής δεν έχει επιβεβαιώσει τη συμμετοχή του για φέτος</span>
											</v-tooltip>
										</template>
										<template v-else>
											<p style="height: 6px">
												{{ item.distributionPointName }}
											</p>
										</template>
									</template>


									<template v-slot:item.actions="{ item }">

										<v-tooltip left>
											<template v-slot:activator="{ on, attrs }">
												<v-icon color="red"
														@click="removeDistPointConfirm(item)"
														v-on="on"
														class="mr-2">mdi-delete-forever
												</v-icon>
											</template>
											<span>
													Διαγραφή Σημείου Διανομής
												</span>
										</v-tooltip>

										<v-tooltip left>
											<template v-slot:activator="{ on, attrs }">
												<v-icon color="secondary"
														@click="getRowItemInfo(item)"
														v-on="on"
														class="mr-2">mdi-magnify
												</v-icon>
											</template>
											<span>Λεπτομέρειες</span>
										</v-tooltip>

									</template>

								</v-data-table>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>

				<v-row>
					<v-col>
						<v-card>
							<v-card-title class="py-0">

								<v-row class="py-0">
									<v-col cols="4">
										<p class=" text--primary ml-3 mt-2">Διαθέσιμα Σημεία Διανομής</p>
									</v-col>
<!--									<v-col  cols="3">-->
<!--										<v-autocomplete class="mx-2" label="Νομός" @change="atPrefectureSelect($event)"-->
<!--														v-model="selectedPrefecture" clearable-->
<!--														:items="$store.getters.prefectures" outlined dense-->
<!--														@click:clear="this.selectedPrefecture=null"-->
<!--														item-value="id" item-text="name"/>-->
<!--									</v-col>-->

<!--									<v-col  cols="3">-->
<!--										<v-autocomplete class="mx-2" label="Δήμος"-->
<!--														v-model="selectedCity" clearable-->
<!--														:items="cities" outlined dense-->
<!--														@click:clear="this.selectedCity=null"-->
<!--														item-value="id" item-text="name"/>-->
<!--									</v-col>-->
<!--									<v-col  cols="2">-->
<!--										<v-btn block outlined color="primary" @click="searchAvailableDps">-->
<!--											<v-icon color="primary">mdi-magnify</v-icon>-->
<!--										</v-btn>-->
<!--									</v-col>-->

								</v-row>
							</v-card-title>
							<v-row>
								<v-col cols="7">
									<v-row>
										<v-col cols="7" class="ml-4">
											<v-text-field
													append-icon="search"
													hide-details @click:clear="searchSecondTable= ''"
													label="Αναζήτηση"
													single-line clearable
													v-model="searchSecondTable"
											></v-text-field>
										</v-col>
										<v-col cols="4"  class="pa-0 mt-2">
											<v-chip-group
													v-model="secondTableFilter"
													mandatory class="mt-2 ml-2">
												<v-chip
														filter
														outlined
														color="primary"
														value="all">
													Όλα
												</v-chip>
												<v-chip class="ml-2"
														filter
														outlined
														color="primary"
														value="members">
													Με συμμετοχή
												</v-chip>
											</v-chip-group>
										</v-col>
									</v-row>
								</v-col>
								<v-col cols="5">
									<v-row>
										<v-col  cols="4">
											<v-autocomplete class="mx-2" label="Νομός" @change="atPrefectureSelect($event)"
															v-model="selectedPrefecture" clearable
															:items="$store.getters.prefectures" outlined dense
															@click:clear="this.selectedPrefecture=null"
															item-value="id" item-text="name"/>
										</v-col>

										<v-col  cols="4">
											<v-autocomplete class="mx-2" label="Δήμος"
															v-model="selectedCity" clearable
															:items="cities" outlined dense
															@click:clear="this.selectedCity=null"
															item-value="id" item-text="name"/>
										</v-col>
										<v-col  cols="3">
											<v-btn block outlined color="primary" @click="searchAvailableDps">
												<v-icon color="primary">mdi-magnify</v-icon>
											</v-btn>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
<!--							<v-row>-->
<!--								<v-col cols="4" class="ml-4">-->
<!--									<v-text-field-->
<!--											append-icon="search"-->
<!--											hide-details @click:clear="searchSecondTable= ''"-->
<!--											label="Αναζήτηση"-->
<!--											single-line clearable-->
<!--											v-model="searchSecondTable"-->
<!--									></v-text-field>-->
<!--								</v-col>-->
<!--								<v-col cols="7" xl="7" lg="7" md="6" sm="6" class="pa-0 mt-2">-->
<!--									<v-chip-group-->
<!--											v-model="secondTableFilter"-->
<!--											mandatory class="mt-2 ml-2">-->
<!--										<v-chip-->
<!--												filter-->
<!--												outlined-->
<!--												color="primary"-->
<!--												value="all">-->
<!--											Όλα-->
<!--										</v-chip>-->
<!--										<v-chip class="ml-2"-->
<!--												filter-->
<!--												outlined-->
<!--												color="primary"-->
<!--												value="members">-->
<!--											Με συμμετοχή-->
<!--										</v-chip>-->
<!--									</v-chip-group>-->
<!--								</v-col>-->
<!--							</v-row>-->
<!--							<v-row justify="start" class="my-0 py-0">-->
<!--								<v-col cols="6" class="my-0 py-0">-->
<!--									<v-row class="my-0 py-0">-->
<!--										<v-col  cols="3">-->
<!--											<v-autocomplete class="mx-2" label="Νομός" @change="atPrefectureSelect($event)"-->
<!--															v-model="selectedPrefecture" clearable-->
<!--															:items="$store.getters.prefectures" outlined dense-->
<!--															@click:clear="this.selectedPrefecture=null"-->
<!--															item-value="id" item-text="name"/>-->
<!--										</v-col>-->

<!--										<v-col  cols="3">-->
<!--											<v-autocomplete class="mx-2" label="Δήμος"-->
<!--															v-model="selectedCity" clearable-->
<!--															:items="cities" outlined dense-->
<!--															@click:clear="this.selectedCity=null"-->
<!--															item-value="id" item-text="name"/>-->
<!--										</v-col>-->
<!--										<v-col  cols="2">-->
<!--											<v-btn block outlined color="primary" @click="searchAvailableDps">-->
<!--												<v-icon color="primary">mdi-magnify</v-icon>-->
<!--											</v-btn>-->
<!--										</v-col>-->
<!--									</v-row>-->
<!--								</v-col>-->
<!--							</v-row>-->
							<v-data-table
									:headers="headers"
									:items="secondTableFilteredItems"
									class="elevation-1" :sort-by="['cityName']"
									:sort-desc="[false]"
									dense item-key="id"
									no-data-text="Δεν υπάρχουν δεδομένα.">

								<template v-slot:item.distributionPointName="{ item }">
									<v-tooltip top>
										<template v-slot:activator="{ on, attrs }">
											<v-chip v-if="!item.hasMembership" v-on="on"
													color="red" outlined class="my-1"
													dense shaped style=" max-width: 120ch;text-wrap: normal">
												<v-icon left size="21" class="mr-1">mdi-alert-outline
												</v-icon>
												<span class="text-truncate">{{item.distributionPointName}}</span>

											</v-chip>
											<p style="height: 6px" v-else>
												{{item.distributionPointName}}
											</p>
										</template>
										<span>Το σημείο διανομής δεν έχει επιβεβαιώσει τη συμμετοχή του για φέτος</span>
									</v-tooltip>

								</template>
								<template v-slot:item.actions="{ item }">

									<v-tooltip left>
										<template v-slot:activator="{ on, attrs }">
											<v-icon color="lightSeaGreen" :disabled="!item.hasMembership"
													@click="addDistPoint(item)"
													v-on="on"
													class="mr-2">mdi-map-marker-plus
											</v-icon>
										</template>
										<span>
										Προσθήκη Σημείου Διανομής
									</span>
									</v-tooltip>

									<v-tooltip left>
										<template v-slot:activator="{ on, attrs }">
											<v-icon color="secondary"
													@click="getRowItemInfo(item)"
													v-on="on"
													class="mr-2">mdi-magnify
											</v-icon>
										</template>
										<span>Λεπτομέρειες</span>
									</v-tooltip>

								</template>

							</v-data-table>
						</v-card>
					</v-col>
				</v-row>
			</v-col>
		</v-row>

		<DistributionRemovalDialog ref="distributionRemovalDialog" @remove-after-confirm="strongConfirmedRemoval"/>
		<DistributionPointInfoDialog :dist-point="distPointForDialog" :key="dialogRerenderKey"/>
		<CustomWindowConfirm ref="confirmDialog"/>
	</v-container>


</template>

<script>

	import request from '../../requests'
	import utils from '../../utilities'
	import DistributionPointInfoDialog from "./DistributionPointInfoDialog";
	import DistributionRemovalDialog from "./DistributionRemovalDialog";
	import CustomWindowConfirm from "../CustomWindowConfirm";
	import properties from "../../properties";

	export default {
		name: "DistributionPoint",
		components: {CustomWindowConfirm, DistributionRemovalDialog, DistributionPointInfoDialog},
		data: () => ({
			utils,
			firstTableFilter: 'all',
			secondTableFilter: 'members',
			tableRerenderKey: 0,
			selectedDistPoints: [],
			selectedDistPointsHaveNoMembership: false,
			availableDistPoints: [],
			lastDistPointIdRequest: '',
			dialogRerenderKey: 0,
			distPointForDialog: {},
			search: '',
			searchSecondTable: '',
			checked: false,
			headers: [
				{text: 'Κωδικός', align: 'center', sortable: true, value: 'id', width: '10%'},
				{text: 'Τίτλος', value: 'distributionPointName', align: 'center', sortable: true, width: '65%'},
				{text: 'Νομός', value: 'prefectureName', align: 'center', sortable: true, width: '10%'},
				{text: 'Δήμος', value: 'cityName', align: 'center', sortable: true, width: '10%'},
				{text: 'Ενέργειες', align: 'center', sortable: true, value: 'actions', width: '5%'},
			],
			requestObjectForRemoval: {
				distPointIds:[],
				check:true
			},
			selectedPrefecture: null,
			cities: [],
			selectedCity: null,
			asyncRequests: 0,
		}),

		computed: {
			firstTableFilteredItems: function () {

				//check if active/inactive toggle buttons are pressed and filter books accordingly
				let filteredByMembership = this.selectedDistPoints.filter((distPoint) => {

					if (this.firstTableFilter === 'members') {
						return distPoint.hasMembership;
					} else if (this.firstTableFilter === 'noMembers') {
						return !distPoint.hasMembership;
					} else {
						return distPoint;
					}
				});
				var vm = this;
				// re-filter the remaining distPointswith search
				return filteredByMembership.filter((distPoint2) => {
					if (vm.search.trim().length > 0) {

						// compare fields with the search text and with pricing filter
						if (distPoint2.distributionPointName !== '' && distPoint2.distributionPointName != null) {
							if (distPoint2.distributionPointName.toLowerCase().indexOf(vm.search.toLowerCase()) !== -1) {
								return distPoint2.distributionPointName.toLowerCase().match(vm.search.toLowerCase());
							}
						}
						if (distPoint2.id !== '' && distPoint2.id != null) {
							if (distPoint2.id.toString().indexOf(vm.search) !== -1) {
								return distPoint2.id.toString().match(vm.search);
							}
						}

						if (distPoint2.prefectureName !== '' && distPoint2.prefectureName != null) {
							if (distPoint2.prefectureName.toLowerCase().indexOf(vm.search.toLowerCase()) !== -1) {
								return distPoint2.prefectureName.toLowerCase().match(vm.search.toLowerCase());
							}
						}

						if (distPoint2.cityName !== '' && distPoint2.cityName != null) {
							if (distPoint2.cityName.toLowerCase().indexOf(vm.search.toLowerCase()) !== -1) {
								return distPoint2.cityName.toLowerCase().match(vm.search.toLowerCase());
							}
						}

					} else {
						return filteredByMembership;
					}
				});
			},

			secondTableFilteredItems: function () {

				//check if active/inactive toggle buttons are pressed and filter books accordingly
				let filteredByMembership = this.availableDistPoints.filter((distPoint) => {

					if (this.secondTableFilter === 'members') {
						return distPoint.hasMembership;
					} else if (this.secondTableFilter === 'noMembers') {
						return !distPoint.hasMembership;
					} else {
						return distPoint;
					}
				});
				var vm = this;
				// re-filter the remaining distPoints with search
				return filteredByMembership.filter((distPoint2) => {
					if (vm.searchSecondTable.trim().length > 0) {

						// compare fields with the search text and with pricing filter
						if (distPoint2.distributionPointName !== '' && distPoint2.distributionPointName != null) {
							if (distPoint2.distributionPointName.toLowerCase().indexOf(vm.searchSecondTable.toLowerCase()) !== -1) {
								return distPoint2.distributionPointName.toLowerCase().match(vm.searchSecondTable.toLowerCase());
							}
						}
						if (distPoint2.id !== '' && distPoint2.id != null) {
							if (distPoint2.id.toString().indexOf(vm.searchSecondTable) !== -1) {
								return distPoint2.id.toString().match(vm.searchSecondTable);
							}
						}

					} else {
						return filteredByMembership;
					}
				});
			},
		},

		methods: {

			returnYearText(year) {
				return year + ' - ' + parseInt(year + 1)
			},

			atPrefectureSelect(prefectureId) {
				this.selectedPrefecture = prefectureId;
				let reqObject = {
					prefectureId: this.selectedPrefecture
				};
				this.$store.commit('setLoadingModal', true);
				request.put('rest/user/prefecture-cities', reqObject, (resp) => {
					this.cities = resp;
					this.$store.commit('setLoadingModal', false);
					this.selectedCity = null

				});
			},

			addDistPoint(item) {
				this.$store.commit('setLoadingModal', true);
				let reqObject = [];
				reqObject.push(item.id);

				request.put('rest/distribution-points/add-distribution-points-to-publisher', reqObject, () => {
					this.getDistributionPointsExceptSelectedFromPublisher(true);
					this.getDistributionPointsOfPublisher(true);
				});
			},

			async removeDistPointConfirm(item) {
				document.activeElement.blur();
				const ok = await this.$refs.confirmDialog.show({
					message: 'Θέλετε να προχωρήσετε στη διαγραφή του [' + item.id + '] ' + item.distributionPointName + '?  Σημειωτέον πως το εκάστοτε Σημείο Διανομής θα αφαιρεθεί και από την καρτέλα Απόθεμα.'
				});

				if (ok) {
					this.removeDistPoint(item);
				}

			},


			removeDistPoint(item) {
				this.selectedCity = item.cityId;
				this.selectedPrefecture = item.prefectureId;
				let requestCities = {
					cityId: this.selectedCity
				};
				request.put('rest/user/prefecture-cities', requestCities, (resp) => {
					this.cities = resp;
				});
				this.$store.commit('setLoadingModal', true);

				let dpList = [];
				dpList.push(item.id);
				this.requestObjectForRemoval.distPointIds = dpList;
				//1st we allow to check for statement books
				this.requestObjectForRemoval.check = true;
				this.removeDistPointRequest();

			},

			strongConfirmedRemoval(){
				this.$store.commit('setLoadingModal', true);
				// after 2nd confirm we skip the check
				this.requestObjectForRemoval.check = false;
				this.removeDistPointRequest();
			},

			removeDistPointRequest(){
				request.removeDistPoint(this.requestObjectForRemoval, () => {
						//success callback
						this.getDistributionPointsExceptSelectedFromPublisher(true);
						this.getDistributionPointsOfPublisher(true);
					}, (error) => {
						//error callback
						this.$store.commit('setLoadingModal', false);
						if (error.toString().includes('{dist.point.has.statementBooks}')) {
							this.$refs.distributionRemovalDialog.show();
						} else {
							properties.getErrorMessage(error);
						}
					}
				);
			},

			searchAvailableDps() {
				this.$store.commit('setLoadingModal', true);
				this.getDistributionPointsExceptSelectedFromPublisher(false);
				// this.getDistributionPointsOfPublisher(true);
			},

			getRowItemInfo(item) {
				this.distPointForDialog = item;
				this.$store.commit('setDistPointInfoDialog', true);
				this.dialogRerenderKey++;
			},

			getDistributionPointsExceptSelectedFromPublisher(withAsyncResponse) {
				this.$store.commit('setLoadingModal', true);
				let reqObject = {
					cityId: this.selectedCity,
					prefectureId: this.selectedPrefecture
				};

				request.put('rest/distribution-points/all-except-selected', reqObject, (resp) => {
					this.availableDistPoints = resp;
					if (withAsyncResponse) {
						this.asyncRequests++;
					} else {
						this.$store.commit('setLoadingModal', false);
					}
				})
			},

			getDistributionPointsOfPublisher(withAsyncResponse) {
				let reqObject = {
					cityId: null,
					prefectureId: null
				};
				request.put('rest/distribution-points/selected', reqObject, (resp) => {
					this.selectedDistPoints = resp.distPoints;
					this.selectedDistPointsHaveNoMembership = resp.hasNoMembershipDistPoints;
					if (withAsyncResponse) {
						this.asyncRequests++;
					} else {
						this.$store.commit('setLoadingModal', false);
					}
				})

			},


		},

		watch: {
			'asyncRequests': function (val) {
				if (val === 2) {
					this.$store.commit('setLoadingModal', false);
					this.asyncRequests = 0;
				}
			},
		},

		created() {
			window.scrollTo(0, 0);
			this.$store.commit('setLoadingModal', true);
			this.getDistributionPointsOfPublisher(false);

		}
	}
</script>

<style scoped>

</style>